var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mb-3" }, [
    _c("label", [_vm._v(_vm._s(_vm.locale))]),
    _vm._v(" "),
    _c("div", { staticClass: "input-group" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.value,
            expression: "value"
          }
        ],
        staticClass: "form-control",
        attrs: { type: "text", placeholder: _vm.placeholder },
        domProps: { value: _vm.value },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.value = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "input-group-append" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary",
            on: { click: _vm.autoTranslate }
          },
          [_c("i", { staticClass: "fa fa-language" })]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }